export class PageLayout {
    _id: string;
    name: string;
    sections : any;
    createdAt: Date;
    updatedAt: Date;
}

export class PageLayoutSection {
    sectionName: string;
    sectionImage: string;
    sectionTitle: string;
    sectionHtmlBody: string;
}